import React from 'react'
import styled from '@emotion/styled'
import { AlphamapLogoThrobber } from 'src/components/alphamap-logo/throbber'

const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`
export const FullScreenLoading: React.FC = () => {
  return (
    <Container style={{ justifyContent: 'center', alignItems: 'center', flex: '1 0 100%' }}>
      <AlphamapLogoThrobber />
    </Container>
  )
}
